import React, { Component, Suspense } from 'react';
import { Button, Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row, FormGroup, Label  } from 'reactstrap';
import AddButtonComponent from '../../../Components/AddButtonComponent';
import { Login_ACTION, AccessStudent_ACTION } from '../../../Actions/AuthorizationActions';
import {connect} from 'react-redux'
import { LOGIN_STATUS_VALID } from '../../../Reducers/AuthorizationReducer';
import { Redirect } from 'react-router-dom';
import { AppFooter } from '@coreui/react';
import DefaultFooter from '../../../containers/DefaultLayout/DefaultFooter';
import { Routes } from '../../../Services/API';
import SearchingTitleComponent from '../../../Components/SearchingTitleComponent';
import { GetListAttempt_ACTION } from '../../../Actions/LogisticActions';
import { responsiveFontSize, responsiveHeight, responsiveWidth } from '../../../Services/Utilities';

class Login extends Component {

  constructor(props){
    super(props)

    this.state = {
      SelectedDP:{}
    }

}

componentWillMount(){
  this.props.GetDataPools()
}

  render() {
    console.log(this)
    if(this.props.IsStudent)
    {
      return(
        <Redirect  from="/login" to="/dashboard"/>
      )
    }

    if(this.props.token && this.props.LoginStatus == LOGIN_STATUS_VALID)
    {
      return(
        <Redirect  from="/login" to="/dashboard"/>
      )
    }

    return (
      <div className="app flex-row align-items-center">
        <Container>
        
          <Row className="justify-content-center">
            <Col md="12">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form>
                      <h1>Login</h1>
                      <p className="text-muted">If you are a System User, Sign In to your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="Username" autoComplete="username" 
                        onChange = {(e) => this.setState({
                          username: e.target.value.trim()
                        })}
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type={this.state.ShowPassword ? "text" : "password"} placeholder="Password" autoComplete="current-password"
                        onChange = {(e) => this.setState({
                          passowrd: e.target.value.trim()
                        })}
                        />
                        
                      </InputGroup>
                      <div style = {{marginTop: responsiveHeight(-2)}}>
                        <FormGroup
                                    check
                                    inline
                                >
                                    <Input 
                                    checked = {this.state.ShowPassword}
                                    type="checkbox"  onChange={(e) => {
                                        
                                        this.setState(prev => ({
                                          ShowPassword: !prev.ShowPassword
                                        }))
                                    }}/>
                                    <Label check style = {{fontSize: responsiveFontSize(0.8)}}>
                                    Show password
                                    </Label>
                                </FormGroup>
                        </div>
                      <hr/>
                      <p className="text-muted">Choose a [DataPool]</p>

                      <div style = {{height: responsiveHeight(20), overflowY:'scroll'}}  className = "border border-secondary">
                      {(this.props.IsDPsSearching || this.props.GetDPsError)? 
            <SearchingTitleComponent  error = {this.props.GetDPsError} OnError = {() => {}}/>
               : <div style = {{margin:5}}>
                   {(this.props.DPs ? this.props.DPs : []).map((dp,i) => (
                       <div key = {i} style = {{width:'95%', marginLeft:'2%'}}>
                           <Row style = {{cursor:'pointer', width:'95%', marginLeft:'2%', borderRadius: responsiveFontSize(0.25)}} onClick = {() => {
                             this.setState({
                               SelectedDP: dp
                             })
                           }}
                           className = {this.state.SelectedDP.Id == dp.Id ? "border border-secondary" : ""}
                           >
                           <Col xs = {1}>
                               <p className="text-muted">{i+1}</p>
                           </Col>
                           <Col xs = {10}>
                               <p style = {{color:'#0099cc'}}>
                                   {dp.Name}  
                               </p>
                           </Col>
                          
                           </Row>
                       </div>
                   ))}
                                         </div>}

                      </div>
                      <hr/>
                      <div 
                      style = {{width:'100%', flexDirection:'column', display:'flex',
                       alignContent:'flex-start', alignItems:'flex-start'}}>
                      <div style = {{marginLeft:'3%'}}>
                      <AddButtonComponent 
                            Title = "Login"
                            Color = "primary"
                            IsAdding = {this.props.IsLogging}
                            AddError = {this.props.LoggingError}
                            onClick = {() => {
                                if(!this.state.SelectedDP.Id){
                                  alert("Please choose a [DataPool]")
                                  return
                                }

                                localStorage.setItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG', this.state.SelectedDP.Id) 
                                localStorage.setItem('USER_DATA_POOL_NAME_HEAT_QUIZ_APP_1567CDFG', this.state.SelectedDP.Name) 

                                this.props.Loggin(this.state.username, this.state.passowrd)
                            }}
                          />
                      </div>
                          <h6 style = {{fontSize: responsiveFontSize(0.7), color:'red', marginTop: responsiveHeight(-0.2)}}>
                              {this.props.GeneralError}
                          </h6>
                      </div>
                      
                    </Form>
                  </CardBody>
                </Card>
                <Card style={{ width: '44%' }}>
                  <CardBody className="text-center">
                    <div style = {{cursor:'pointer', alignItems:'center', alignContent:'center', flexDirection:'column', display:'flex'}} onClick = {() => {
                      this.props.AccessAsStudent()
                    }}>
                      <h1>Student / Guest</h1>
                      <p className="text-muted">If you are a Student / Guest, Click to Enter</p>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
          

        </Container>
      </div>
    );
  }
}

//Constant
const DP_SEARCHING_PARAMETER = 'IsDPSearching'
const DP_IS_ADDING_PARAMTER = 'IsDPAdding'

const DP_DATA_PARAMETER = 'DPs'

const DP_GET_ERROR_PARAMETER = 'DPGetError'
const DP_ADD_ERROR_PARAMETER = 'DPAddError'

const GENERAL_ERROR_PARAMETER = "GeneralError"

//Constant
function MapStateToProps(state) {
    console.log(state)
    return {
        IsLogging: state.Authorization.IsLogging,
        LoggingError: state.Authorization.LoggingError,
        token: state.Authorization.token,
        LoginStatus:state.Authorization.LoginStatus,
        IsStudent: state.Authorization.student,

        DPs:state.Query[DP_DATA_PARAMETER],
        IsDPsSearching: state.Query[DP_SEARCHING_PARAMETER],
  
        GetDPsError: state.Query[DP_GET_ERROR_PARAMETER],
        GeneralError: state.Query[GENERAL_ERROR_PARAMETER],
      }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        Loggin: (username, passowrd) => {dispatch(Login_ACTION(
          username,
          passowrd
        ))},
        AccessAsStudent: () => {dispatch(AccessStudent_ACTION(true))},

        GetDataPools: () => {dispatch(GetListAttempt_ACTION({
          SearchParameter: DP_SEARCHING_PARAMETER,
          DataParameter: DP_DATA_PARAMETER,
          GetErrorParameter: DP_GET_ERROR_PARAMETER,

          Path: Routes.GetDataPools,
  
          [DP_SEARCHING_PARAMETER]: true,
          [DP_DATA_PARAMETER]: [],
          [DP_GET_ERROR_PARAMETER]: '',
      }))},
    }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(Login)

